import styled from 'styled-components';

export const selectStyles: React.CSSProperties = {
	minWidth: '10rem',
};

export const DefaultLabel = styled.label`
	display: inline-block;
	font-size: 1rem;
	line-height: 2rem;
`;
